import "./IntroZone.css";

const IntroZone = () => {
  return (
    <div className="img-banner">
      <div className="img-banner-text">
        <p>
          Women-owned private equity firm focused on growing exceptional
          companies
        </p>
      </div>
    </div>
  );
};

export default IntroZone;
